/** @format */

import type { Part, Tool } from "../types/sop";

const gen = () => crypto.randomUUID();

/** Ensure each part has a stable id so React can track items by identity, not index. */
export function ensurePartIds(parts: Part[] | undefined, stepIndex: number): Part[] {
  if (!parts?.length) return [];
  return parts.map((p, i) => ({
    ...p,
    id: p.id ?? `part-${stepIndex}-${i}`,
  }));
}

/** Ensure each tool has a stable id so React can track items by identity, not index. */
export function ensureToolIds(tools: Tool[] | undefined, stepIndex: number): Tool[] {
  if (!tools?.length) return [];
  return tools.map((t, i) => ({
    ...t,
    id: t.id ?? `tool-${stepIndex}-${i}`,
  }));
}

export function generatePartId(): string {
  return gen();
}

export function generateToolId(): string {
  return gen();
}
